import { Container, Row, Col, Card } from "react-bootstrap";

export default function FinancialServices() {
  return (
    <Container fluid className="py-5 bg-white">
      <h2 className="text-center text-primary fw-bold">Financial Services</h2>
      <p className="mt-3 text-center text-secondary fs-5">
        Providing expert financial consulting, project financing, and investment solutions for infrastructure growth.
      </p>

      <Row className="mt-4 justify-content-center g-4">
        <Col xs={12} md={6} lg={4}>
          <Card className="shadow border-0" style={{padding: "5px" }}>
            <Card.Body>
              <Card.Title className="text-primary fw-bold">Project Financing</Card.Title>
              <Card.Text className="text-secondary">
                Offering structured finance solutions for large-scale infrastructure projects.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={6} lg={4}>
          <Card className="shadow border-0" style={{padding: "5px" }}>
            <Card.Body>
              <Card.Title className="text-primary fw-bold">Investment Advisory</Card.Title>
              <Card.Text className="text-secondary">
                Providing expert financial insights for sustainable investments.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
